import _ from 'lodash';
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import Checkbox from '@material-ui/core/Checkbox';
import TextField from '@material-ui/core/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete';
import CheckBoxOutlineBlankIcon from '@material-ui/icons/CheckBoxOutlineBlank';
import CheckBoxIcon from '@material-ui/icons/CheckBox';
import Grid from '@material-ui/core/Grid';
import FormControl from '@material-ui/core/FormControl';
import FormHelperText from '@material-ui/core/FormHelperText';
import { sortStationsByNumber } from '../../libs/utility';

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;

export default class FMPStationMultiSelect extends PureComponent {
	render() {
		const { label, value, path, onChange, stations, error, helpText, md, disabled } = this.props;

		const sorted = sortStationsByNumber(stations);
		const options = sorted.map((station) => {
			const { stationId, number, name } = station;
			return { value: stationId, display: `${number} - ${name}` };
		});

		const _onChange = (event, onChangeValue) => {
			if (_.isEmpty(onChangeValue)) {
				onChange([], path);
				return;
			}
			const stationIds = _.map(onChangeValue, 'value');
			onChange(stationIds, path);
		};

		const selectedOptions = [];
		value.forEach((id) => {
			if (_.isEmpty(options)) {
				return;
			}
			selectedOptions.push(_.find(options, { value: id }));
		});

		const hasError = !!error;
		return (
			<Grid item xs={12} md={md}>
				<FormControl fullWidth={true} error={hasError} disabled={disabled}>
					<Autocomplete
						multiple
						options={options}
						value={selectedOptions}
						disableCloseOnSelect
						onChange={_onChange}
						getOptionLabel={(option) => option.display}
						getOptionSelected={(option, value) => {
							return option.value === value.value;
						}}
						disabled={disabled}
						renderOption={(option, { selected }) => (
							<React.Fragment>
								<Checkbox
									size={'small'}
									icon={icon}
									checkedIcon={checkedIcon}
									style={{ marginRight: 8 }}
									checked={selected}
								/>
								{option.display}
							</React.Fragment>
						)}
						renderInput={(params) => <TextField {...params} label={label} placeholder="Pick multiple" fullWidth />}
					/>
					{hasError && <FormHelperText>{error}</FormHelperText>}
					{helpText && !hasError && <FormHelperText>{helpText}</FormHelperText>}
				</FormControl>
			</Grid>
		);
	}
}

FMPStationMultiSelect.propTypes = {
	label: PropTypes.string,
	value: PropTypes.array,
	path: PropTypes.string.isRequired,
	onChange: PropTypes.func.isRequired,
	error: PropTypes.string,

	stations: PropTypes.array.isRequired,
	md: PropTypes.number,
	helpText: PropTypes.string,
	readOnly: PropTypes.bool,
	multiple: PropTypes.bool,
	disabled: PropTypes.bool,
};

FMPStationMultiSelect.defaultProps = {
	label: 'Carrier',
	readOnly: false,
	md: 12,
};
